// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ===========================
   Desktop
=========================== */

.navbar {
  width: 100%;
  min-height: 90px;
  padding: 12px clamp(20px, 3vw, 40px);

  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: clamp(20px, 4vw, 80px);

  background: #ffffff;
  border-bottom: 4px solid #f5d000;
  box-shadow: 0 2px 12px rgba(23, 33, 26, 0.08);
  box-sizing: border-box;
}

/* ---------- Left Logo ---------- */

.navbar-brand {
  flex-shrink: 0;
  display: flex;
  align-items: center;
}

.navbar-logo {
  display: block;
  height: clamp(55px, 5vw, 78px);
  width: auto;
  object-fit: contain;
}

/* ---------- Title ---------- */

.navbar-title {
  flex: 1 1;

  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-end;

  text-align: right;
  padding-right: 10px;
}

.navbar-title h1 {
  margin: 0;
  color: #277a3e;
  font-size: clamp(1.8rem, 2vw, 2.5rem);
  font-weight: 750;
  line-height: 1.05;
}

.navbar-title p {
  margin-top: 4px;
  color: #617067;
  font-size: clamp(0.85rem, 0.95vw, 1.05rem);
  line-height: 1.3;
}

/* ===========================
   Large Tablets
=========================== */

@media (max-width: 1100px) {

  .navbar {
    padding: 12px 24px;
    gap: 40px;
  }

  .navbar-logo {
    height: 68px;
  }

  .navbar-title h1 {
    font-size: 2.1rem;
  }

  .navbar-title p {
    font-size: 0.95rem;
  }

}

/* ===========================
   Tablets
=========================== */

@media (max-width: 900px) {

  .navbar {
    flex-direction: column;
    align-items: center;
    justify-content: center;

    gap: 16px;
    padding: 18px;
  }

  .navbar-brand {
    justify-content: center;
    width: 100%;
  }

  .navbar-logo {
    height: 70px;
  }

  .navbar-title {
    align-items: center;
    text-align: center;
    width: 100%;
  }

  .navbar-title h1 {
    font-size: 2rem;
  }

  .navbar-title p {
    font-size: 0.95rem;
  }

}

/* ===========================
   Phones
=========================== */

@media (max-width: 600px) {

  .navbar {
    padding: 16px;
    gap: 14px;
  }

  .navbar-logo {
    height: 58px;
  }

  .navbar-title h1 {
    font-size: 1.7rem;
  }

  .navbar-title p {
    font-size: 0.85rem;
  }

}

/* ===========================
   Small Phones
=========================== */

@media (max-width: 400px) {

  .navbar {
    padding: 14px;
  }

  .navbar-logo {
    height: 50px;
  }

  .navbar-title h1 {
    font-size: 1.5rem;
  }

  .navbar-title p {
    font-size: 0.8rem;
  }

}`, "",{"version":3,"sources":["webpack://./src/components/Navbar/Navbar.css"],"names":[],"mappings":"AAAA;;6BAE6B;;AAE7B;EACE,WAAW;EACX,gBAAgB;EAChB,oCAAoC;;EAEpC,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,2BAA2B;;EAE3B,mBAAmB;EACnB,gCAAgC;EAChC,6CAA6C;EAC7C,sBAAsB;AACxB;;AAEA,oCAAoC;;AAEpC;EACE,cAAc;EACd,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,8BAA8B;EAC9B,WAAW;EACX,mBAAmB;AACrB;;AAEA,gCAAgC;;AAEhC;EACE,SAAO;;EAEP,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,qBAAqB;;EAErB,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,cAAc;EACd,qCAAqC;EACrC,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,cAAc;EACd,0CAA0C;EAC1C,gBAAgB;AAClB;;AAEA;;6BAE6B;;AAE7B;;EAEE;IACE,kBAAkB;IAClB,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;;6BAE6B;;AAE7B;;EAEE;IACE,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;;IAEvB,SAAS;IACT,aAAa;EACf;;EAEA;IACE,uBAAuB;IACvB,WAAW;EACb;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;IACnB,kBAAkB;IAClB,WAAW;EACb;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;;6BAE6B;;AAE7B;;EAEE;IACE,aAAa;IACb,SAAS;EACX;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;EACpB;;AAEF;;AAEA;;6BAE6B;;AAE7B;;EAEE;IACE,aAAa;EACf;;EAEA;IACE,YAAY;EACd;;EAEA;IACE,iBAAiB;EACnB;;EAEA;IACE,iBAAiB;EACnB;;AAEF","sourcesContent":["/* ===========================\n   Desktop\n=========================== */\n\n.navbar {\n  width: 100%;\n  min-height: 90px;\n  padding: 12px clamp(20px, 3vw, 40px);\n\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  gap: clamp(20px, 4vw, 80px);\n\n  background: #ffffff;\n  border-bottom: 4px solid #f5d000;\n  box-shadow: 0 2px 12px rgba(23, 33, 26, 0.08);\n  box-sizing: border-box;\n}\n\n/* ---------- Left Logo ---------- */\n\n.navbar-brand {\n  flex-shrink: 0;\n  display: flex;\n  align-items: center;\n}\n\n.navbar-logo {\n  display: block;\n  height: clamp(55px, 5vw, 78px);\n  width: auto;\n  object-fit: contain;\n}\n\n/* ---------- Title ---------- */\n\n.navbar-title {\n  flex: 1;\n\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  align-items: flex-end;\n\n  text-align: right;\n  padding-right: 10px;\n}\n\n.navbar-title h1 {\n  margin: 0;\n  color: #277a3e;\n  font-size: clamp(1.8rem, 2vw, 2.5rem);\n  font-weight: 750;\n  line-height: 1.05;\n}\n\n.navbar-title p {\n  margin-top: 4px;\n  color: #617067;\n  font-size: clamp(0.85rem, 0.95vw, 1.05rem);\n  line-height: 1.3;\n}\n\n/* ===========================\n   Large Tablets\n=========================== */\n\n@media (max-width: 1100px) {\n\n  .navbar {\n    padding: 12px 24px;\n    gap: 40px;\n  }\n\n  .navbar-logo {\n    height: 68px;\n  }\n\n  .navbar-title h1 {\n    font-size: 2.1rem;\n  }\n\n  .navbar-title p {\n    font-size: 0.95rem;\n  }\n\n}\n\n/* ===========================\n   Tablets\n=========================== */\n\n@media (max-width: 900px) {\n\n  .navbar {\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n\n    gap: 16px;\n    padding: 18px;\n  }\n\n  .navbar-brand {\n    justify-content: center;\n    width: 100%;\n  }\n\n  .navbar-logo {\n    height: 70px;\n  }\n\n  .navbar-title {\n    align-items: center;\n    text-align: center;\n    width: 100%;\n  }\n\n  .navbar-title h1 {\n    font-size: 2rem;\n  }\n\n  .navbar-title p {\n    font-size: 0.95rem;\n  }\n\n}\n\n/* ===========================\n   Phones\n=========================== */\n\n@media (max-width: 600px) {\n\n  .navbar {\n    padding: 16px;\n    gap: 14px;\n  }\n\n  .navbar-logo {\n    height: 58px;\n  }\n\n  .navbar-title h1 {\n    font-size: 1.7rem;\n  }\n\n  .navbar-title p {\n    font-size: 0.85rem;\n  }\n\n}\n\n/* ===========================\n   Small Phones\n=========================== */\n\n@media (max-width: 400px) {\n\n  .navbar {\n    padding: 14px;\n  }\n\n  .navbar-logo {\n    height: 50px;\n  }\n\n  .navbar-title h1 {\n    font-size: 1.5rem;\n  }\n\n  .navbar-title p {\n    font-size: 0.8rem;\n  }\n\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
